import Vue from 'vue'; 

Vue.filter('currencyThePrice', value => {
    if(value){
        return (((parseFloat(value))*100)/100).toFixed(2);
    }else{
        return 0;
    }
   
});
